function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useRef as p, useState as O, useEffect as T } from "react";
import { getVariableByCaretPosition as I, calculateOffset as _ } from "./index.es421.js";
import { VARIABLE_NODE_NAME as g, OPENING_PARENTHESES as f, PARENTHESES_LENGTH as N, CLOSING_PARENTHESES as H } from "./index.es494.js";
import { useCaretPosition as L } from "./index.es565.js";
import { VariableState as P } from "./index.es137.js";
var M = function M(_ref) {
  var m = _ref.mirrorRef,
    r = _ref.textareaRef,
    n = _ref.value,
    l = _ref.setPopupOpen,
    E = _ref.validateErrors,
    a = _ref.onChange,
    $ = _ref.onOptionClick,
    C = _ref.isFocused;
  var e = p(null),
    _O = O(""),
    _O2 = _slicedToArray(_O, 2),
    V = _O2[0],
    d = _O2[1],
    s = function s() {
      e.current && (e.current.removeAttribute(P.active), e.current = null);
    },
    S = function S(t) {
      e.current = t, e.current.setAttribute(P.active, ""), d(e.current.textContent || "");
    },
    _L = L(r),
    u = _L.setSavedCaretPositionSingle,
    A = function A(t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var c = _(m, e),
        o = "".concat(f).concat(t).concat(H);
      if (a !== null && a !== void 0 && a("".concat(n.slice(0, c)).concat(o).concat(n.slice(c + V.length))), i) {
        var k = (n.slice(0, c) + o).length;
        u(k);
      }
    },
    b = function b() {
      s(), E(), l(!1);
    };
  return T(function () {
    if (!r.current) return;
    var t = r.current.selectionEnd,
      i = I(m, t);
    i ? (s(), S(i), l(!0)) : b();
  }, [n]), {
    variable: V,
    textareaRef: r,
    activeVariableRef: e,
    onVariableClick: function onVariableClick(t) {
      var i = document.elementsFromPoint(t.clientX, t.clientY);
      if (i.find(function (o) {
        return o.nodeName === "BUTTON";
      })) return;
      var c = i.findLast(function (o) {
        return o.nodeName === g;
      });
      c ? (s(), S(c), l(!0)) : b();
    },
    onVariableIconClick: function onVariableIconClick() {
      if (!r.current || e.current) return;
      var _r$current = r.current,
        t = _r$current.selectionStart,
        i = _r$current.selectionEnd;
      if (C) {
        a !== null && a !== void 0 && a("".concat(n.slice(0, t)).concat(f).concat(n.slice(i))), u(t + N);
        return;
      }
      a !== null && a !== void 0 && a("".concat(n).concat(f)), u(n.length + N);
    },
    onPopupClose: b,
    onPopupOptionClick: function onPopupOptionClick(t) {
      A(String(t.label)), $ === null || $ === void 0 ? void 0 : $(t);
    },
    insertVariable: A,
    resetActiveVariable: s,
    validateErrors: E
  };
};
export { M as useActiveVariable };